import { ISnLayoutConfig } from '../interfaces';
import { SnLayoutNavbarConfig } from '../models';

export function snLayoutNavbarConfigFactory(config: ISnLayoutConfig): SnLayoutNavbarConfig {
  return new SnLayoutNavbarConfig(config.navbar);
}
